export const JOINED = 'JOINED'
export const STARTED = 'STARTED'
export const NOTSTARTED = 'NOTSTARTED'
export const INPROGRESS = 'INPROGRESS'
export const INCOMPLETE = 'INCOMPLETE'
export const COMPLETED = 'COMPLETED'
export const FEEDBACKREQUIRED = 'FEEDBACKREQUIRED'
